import React, { useEffect, useMemo, useState } from "react";

import Container from "../Container";
import Heading from "../Heading";
import ScheduleRow from "../ScheduleRow";
import Tabs from "../Tabs";
import getTime from "../../helpers/getTime";
import moment from "moment";
import { uniq } from "lodash";
import useSchedule from "../../hooks/useSchedule";

export interface ScheduleTableProps {
  isPublic?: boolean;
}

const ScheduleTable = ({ isPublic }: ScheduleTableProps) => {
  const schedule = useSchedule();

  // Extract dates from schedule
  const dates = useMemo(() => {
    return uniq(
      schedule.map((item) => moment(item.timeStart).format("DD MMM YYYY"))
    );
  }, [schedule]);

  // Set active date
  const [activeDate, setActiveDate] = useState<string | undefined>();
  useEffect(() => {
    if (!activeDate) {
      const today = moment(getTime()).format("DD MMM YYYY");
      if (dates.includes(today)) {
        setActiveDate(today);
      } else {
        setActiveDate("24 Nov 2020");
      }
    }
  }, [dates, activeDate]);

  // Filter schedule for date
  const filteredSchedule = useMemo(() => {
    return schedule.filter((item) => {
      if (isPublic && item.private) {
        return false;
      }

      if (activeDate) {
        return (
          new Date(item.timeStart).getDate() === new Date(activeDate).getDate()
        );
      }

      return true;
    });
  }, [schedule, activeDate, isPublic]);

  return (
    <Container>
      <div className="space-y-8">
        <div className="flex flex-wrap items-center justify-center">
          <Heading title="Scientific Program" subtitle="Schedule" />

          <div className="flex w-full my-4">
            <Tabs
              activeTab={activeDate || ""}
              tabs={dates.map((date) => {
                return {
                  title: date,
                  onClick: () => setActiveDate(date),
                };
              })}
            />
          </div>
        </div>

        <div className="w-full">
          {filteredSchedule.map((item, key) => (
            <ScheduleRow
              isLast={key === filteredSchedule.length - 1}
              key={key}
              {...item}
            />
          ))}
        </div>
      </div>
    </Container>
  );
};

export default ScheduleTable;
